import { isSameOrContains } from 'anodum';
import isEmptyEditableElement from '../verifiers/is-empty-editable-element';
import textFormatting from '../../text-formatting';

const removeEmptyListItemsAfterRemoveSelection = (itemsInRange) => {
  const { anchorNode } = textFormatting.accessors.getAdvancedSelection();
  itemsInRange.forEach((item) => {
    if (isEmptyEditableElement(item) && !isSameOrContains(item, anchorNode)) {
      item.remove();
    }
  });
};

export default removeEmptyListItemsAfterRemoveSelection;
